function isFixed(el) {
    let current = el;

    while (current && current !== document.body) {
        const style = window.getComputedStyle(current, null);
        const position = style.getPropertyValue('position');
        if (position === 'fixed') {
            return true;
        }

        current = current.parentNode;
    }

    return false;
}

export function scrollWindowToTarget(target, callback) {
    if (window.HopFlags && window.HopFlags.animationsProfile !== 'full') {
        return;
    }

    if (!target) {
        return;
    }

    if (target instanceof jQuery) {
        target = target[0];
    }

    if (isFixed(target)) {
        if (callback) {
            setTimeout(() => callback(target));
        }

        return;
    }

    const stickyHeader = document.getElementById('profileStickyHeader');

    let heightHeader;
    if (stickyHeader) {
        heightHeader = stickyHeader.offsetHeight;
    } else {
        const header = document.querySelector('.main-header');
        heightHeader = header ? header.offsetHeight : 0;
    }

    const elements = $('html,body');
    const options = {
        scrollTop: $(target).offset().top - heightHeader - 70, // arbitrary offset to ensure target is not hidden by header(s)
    };

    // The `stop` is here to stop the previous animation and trigger the new one.
    elements.stop().animate(options, 600, () => {
        if (callback) {
            callback(target);
        }
    });
}
